// Firebase Configuration
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";
import {
    initializeFirestore,
    persistentLocalCache,
    persistentMultipleTabManager
} from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyC_5A4GFcNfXaXdBsgeVCdiZ1zIICMDLJg",
    authDomain: "meupainel-21dba.firebaseapp.com",
    projectId: "meupainel-21dba",
    storageBucket: "meupainel-21dba.firebasestorage.app",
    messagingSenderId: "959738717502",
    appId: "1:959738717502:web:34f73e888ae861851e386f",
    measurementId: "G-TPG0HKYQJ9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (resiliente para testes e ambientes sem suporte)
let analyticsInstance = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
    try {
        analyticsInstance = getAnalytics(app);
    } catch (e) {
        // Analytics indisponível no ambiente atual
    }
}
export const analytics = analyticsInstance;

// Helper para log de eventos com segurança
export const logAnalyticsEvent = (eventName, params = {}) => {
    if (analytics) {
        logEvent(analytics, eventName, params);
    }
};

// Initialize Firestore with Persistence
export const db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

// Initialize Auth
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
if (googleProvider && typeof googleProvider.setCustomParameters === 'function') {
    googleProvider.setCustomParameters({ prompt: 'select_account' });
}

export default app;

